// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Recommendation_wrap__2b5-_","header":"Recommendation_header__14ORk","text":"Recommendation_text__2i_Ci"};